import { environment } from './environments/environment';

export const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: environment.userPoolId,
      userPoolClientId: environment.userPoolClientId,
      // identityPoolId: 'ap-south-1:xxxx-xxxx-xxxx-xxxx', // optional, only if using Federated Identities
      signUpVerificationMethod: environment.signUpVerificationMethod as 'code' | 'link' | undefined, // or 'link', optional
    },
  },
} as const;
